import { motion } from 'motion/react';

interface VerboLogoProps {
  size?: number;
  dark?: boolean;
  animate?: boolean;
  version?: string;
}

export default function VerboLogo({ size = 28, dark = false, animate = true, version }: VerboLogoProps) {
  const content = (
    <div
      style={{
        display: "flex",
        alignItems: "baseline",
        justifyContent: "center",
        fontWeight: 800,
        fontSize: size * 1.1,
        letterSpacing: "0.04em",
        fontFamily: "Inter, system-ui, sans-serif"
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <span style={{ color: dark ? "#FFFFFF" : "#1C2230" }}>Verb</span>
        <span
          style={{
            color: "#2BB3C0",
          }}
        >
          O
        </span>
      </div>
      {version && (
        <span style={{ 
          fontSize: size * 0.4, 
          marginLeft: "4px", 
          color: dark ? "rgba(255,255,255,0.4)" : "rgba(28,34,48,0.4)",
          fontWeight: 900,
          textTransform: "uppercase",
          letterSpacing: "0.05em"
        }}>
          {version}
        </span>
      )}
    </div>
  );

  if (!animate) return content;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.18, ease: "easeOut" }}
    >
      {content}
    </motion.div>
  );
}
